import { render, staticRenderFns } from "./FiltersPanelRadioGroup.vue?vue&type=template&id=5871f448&scoped=true&"
import script from "./FiltersPanelRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FiltersPanelRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./FiltersPanelRadioGroup.vue?vue&type=style&index=0&id=5871f448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871f448",
  null
  
)

export default component.exports